// IA-1 (editor de descripción): historial de edición PROPIO para Deshacer/Rehacer. Reemplaza el
// `execCommand('undo'/'redo')` nativo, que NO revierte de forma fiable los comandos programáticos
// (createLink se insertaba pero no se deshacía). Al capturar un snapshot del HTML tras CADA acción
// (tipeo, negrita, lista, enlace, pegado, inserción de IA), Deshacer/Rehacer funcionan igual para todas.
// Puro y testeable.

export function crearHistorial(inicial = '') {
  return { pila: [String(inicial || '')], i: 0 };
}

// Registra un estado nuevo. Si es igual al actual, no cambia nada (evita snapshots repetidos). Si se
// venía de un Deshacer (hay estados «adelante»), una edición nueva poda la rama de rehacer.
export function registrar(h, valor) {
  const v = String(valor || '');
  if (v === h.pila[h.i]) return h;
  const pila = h.pila.slice(0, h.i + 1);
  pila.push(v);
  return { pila, i: pila.length - 1 };
}

export function deshacer(h) {
  return h.i > 0 ? { pila: h.pila, i: h.i - 1 } : h;
}

export function rehacer(h) {
  return h.i < h.pila.length - 1 ? { pila: h.pila, i: h.i + 1 } : h;
}

export const valorActual = (h) => h.pila[h.i];
export const puedeDeshacer = (h) => h.i > 0;
export const puedeRehacer = (h) => h.i < h.pila.length - 1;

// Alterna el bloque de la línea entre subtítulo (H3) y párrafo: si ya es H3 vuelve a P, si no lo pone en
// H3. Es la lógica del botón «Subtítulo» (convierte y des-convierte). `actual` = queryCommandValue
// ('formatBlock'), minúsculas; devuelve el argumento para execCommand('formatBlock', ...).
export function siguienteBloque(actual) {
  return String(actual || '').toLowerCase() === 'h3' ? 'P' : 'H3';
}
